import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { _Api } from "../../api/_call";
import barcodePrintOutContext from "../context/BarcodePrintOutContext.js";
import Select from "react-select";
import '../printoutStyle.scss'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PrintPreview from "./PrintPreview";
import InventorySelectToPrintout, { inventoryQueryClient } from "components/inventory/InventorySelectToPrintout";
import { loading, Updateloading,error } from "../../common/helpers/toastify";
import { encodePriceWithCode } from "components/common/helpers/barcodeHelper";
import { Label } from "@mobiscroll/react-lite";
import { FiCopy, FiLock, FiUnlock } from "react-icons/fi";
import { formatWeightValue } from "components/common/barcodeTemplate/printQuantity";
import {
    RecoilRoot,
    useRecoilState,

} from 'recoil';
import { pageStatusState, pageHeadingBreadCrumbState, callerFromState } from "../recoilStateSelector/profilePageState.js";
import { showImportStockIdModalState, selectedInventoryItemsState, countSelectedInventoryItemState, selectedInventoryIdState, currentSelectedIdState, selectedProfileState } from "../recoilStateSelector/PrintPreviewState.js";
import BarcodeConfigPreview from "./BarcodeConfigPreview";
import { prepareBarcodeImage } from "../../../components/common/helpers/barcodeImageHelper";
const printTemplateType = (template_type)=>{
    switch(template_type){
        case "template_1":
        return "Template-01-Barcode"
        case "template_2":
            return "Template-02-Qrcode"

        case "custom_template_01":
            return "Custom-Template-01-Barcode"

            
        case "template_3":
            return "Template-03-RFID"


        default : return ""
         
    }
   }

let config = {
    template_1: {
        barcode: true,
        item: true,
        collection: false,
        item_size: true,
        metal: true,
        weight: true,
        pcs: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: true, // none code retail_price
        text: true,
        image: true
    },
    template_2: {
        barcode: true,
        qr: true,
        item: true,
        collection: false,
        item_size: true,
        metal: true,
        weight: true,
        pcs: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: false, // none code retail_price
        text: true,
        image: true
    },
    template_3: {
        barcode: true,
        qr: true,
        item: true,
        item_size: true,
        metal: true,
        weight: true,
        pcs: true,
        stone_group: true,
        stone_name: true,
        shape: true,
        cut: true,
        color: true,
        clarity: true,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: false, // none code retail_price
        text: true,
        image: true
    },
    custom_template_01: {
        barcode: true,
        item: false,
        collection: true,
        item_size: false,
        metal: true,
        weight: true,
        stone_group: false,
        stone_name: true,
        shape: true,
        cut: false,
        color: false,
        clarity: false,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: true,
        text: false,
        image: true
    },
    custom_template_02: {
        barcode: true,
        item: false,
        collection: true,
        item_size: false,
        metal: true,
        weight: true,
        stone_group: false,
        stone_name: true,
        shape: true,
        cut: false,
        color: false,
        clarity: false,
        stone_size: true,
        stone_pcs: true,
        stone_weight: true,
        price: true,
        text: false,
        image: true
    }

}

const getSelectedTemplateValue = (selected) => {
    if (!selected) return "";
    if (typeof selected === "string") return selected;
    return selected.value || "";
};

const getTemplateConfigByValue = (templateValue) => {
    if (!templateValue) return null;
    if (config[templateValue]) return config[templateValue];
    if (String(templateValue).startsWith("custom_template_")) {
        return config.custom_template_01;
    }
    return null;
};

const DEFAULT_PROFILE_FIELDS = [
    "barcode",
    "item",
    "metal",
    "weight",
    "pcs",
    "stone_name",
    "shape",
    "stone_size",
    "stone_pcs",
    "stone_weight",
    "price",
];

const getTemplateDefaultData = (templateValue) => {
    const templateConfig = getTemplateConfigByValue(templateValue) || {};
    const configCheckList = DEFAULT_PROFILE_FIELDS.filter((fieldName) => (
        Object.prototype.hasOwnProperty.call(templateConfig, fieldName)
    ));

    return {
        config_check_list: configCheckList,
        config_check_info: {
            barcode_display: "stock_id",
            weight_display: "nwt",
            price_display: "retail_price",
            qr_type_display: "offline",
            qr_url_display: "",
            qr_url_depend_location: false,
            text_message: "",
            text_font_size: DEFAULT_TEXT_FONT_SIZE,
            text_config: { position: { ...TEMPLATE3_DEFAULT_TEXT_POSITION } },
            image_config: null,
            template3_field_positions: null,
            preview_stone_count: 2,
        },
        current_template_layout_selected: {
            label: printTemplateType(templateValue),
            value: templateValue,
        },
    };
};

const cloneConfigData = (configData) => {
    const rawCustomConfig = configData?.custom_template_config_info
        ?? configData?.custom_template_config
        ?? null;
    let savedCustomConfig = rawCustomConfig;

    if (typeof rawCustomConfig === "string") {
        try {
            savedCustomConfig = JSON.parse(rawCustomConfig);
        } catch (error) {
            savedCustomConfig = null;
        }
    }

    return {
    config_check_list: [...(configData?.config_check_list || [])],
    config_check_info: { ...(configData?.config_check_info || {}) },
    current_template_layout_selected: configData?.current_template_layout_selected || "",
    custom_template_config: savedCustomConfig,
    custom_template_config_info: savedCustomConfig,
    };
};

const selectLimitOptions = [
    { label: 10, value: 10 },
    { label: 50, value: 50 },
    { label: 100, value: 100 }
]

const PRICE_CODE_FIELDS = [
    { key: "0", label: "0" },
    { key: "1", label: "1" },
    { key: "2", label: "2" },
    { key: "3", label: "3" },
    { key: "4", label: "4" },
    { key: "5", label: "5" },
    { key: "6", label: "6" },
    { key: "7", label: "7" },
    { key: "8", label: "8" },
    { key: "9", label: "9" },
    { key: "repeat", label: "Repeat" },
    { key: "00", label: "00" },
    { key: "prefix", label: "Prefix" },
    { key: "suffix", label: "Suffix" },
];
const PRICE_CODE_DIGIT_FIELDS = PRICE_CODE_FIELDS.filter((f) => /^\d$/.test(f.key));
const PRICE_CODE_SPECIAL_FIELDS = [
    { key: "repeat", label: "Repeat", hint: "Repeats the previous code (a digit or 00)" },
    { key: "00", label: "00", hint: "Used in place of a double zero" },
    { key: "prefix", label: "Prefix", hint: "Printed before the code" },
    { key: "suffix", label: "Suffix", hint: "Printed after the code" },
];
const PRICE_CODE_SAMPLE = "1,250.00";
const DEFAULT_TEXT_FONT_SIZE = 6;
const normalizeTextFontSize = (value) => Math.min(
    20,
    Math.max(1, Number.parseFloat(value) || DEFAULT_TEXT_FONT_SIZE)
);
const TEMPLATE3_DEFAULT_IMAGE_POSITION = { x: 50, y: 9.5 };
// Template 3's latest print tuning: text Y=70 dots and the centered X for
// the current default text size, expressed in the config's millimetres.
const TEMPLATE3_DEFAULT_TEXT_POSITION = { x: 47.3, y: 5.9 };
const TEMPLATE3_DEFAULT_IMAGE_SCALE = 1.4;
// These are only the values shown before a field position is configured.
// Printing still uses the original content-aware X calculations until a user
// explicitly changes one of these fields.
const TEMPLATE3_DEFAULT_FIELD_POSITIONS = {
    qr: {
        sku: { x: 60, y: 14.6 },
        stock_id: { x: 57.2, y: 7.9 },
        metal: { x: 46.7, y: 7.9 },
        weight: { x: 46.7, y: 5.8, size: 27 },
        pcs: { x: 45.1, y: 5.8, size: 15 },
        price: { x: 57.7, y: 5.8 },
    },
    no_qr: {
        sku: { x: 60, y: 27.1 },
        stock_id: { x: 57.2, y: 20.9 },
        metal: { x: 46.7, y: 20.9 },
        weight: { x: 46.7, y: 18.8, size: 27 },
        pcs: { x: 45.1, y: 18.8, size: 15 },
        price: { x: 57.7, y: 18.8 },
    },
};
const NUMERIC_INPUT_PATTERN = /^\d*(?:\.\d*)?$/;

const isEditableNumericValue = (value) => (
    value === "" || NUMERIC_INPUT_PATTERN.test(value)
);

const getTemplate3ImagePositionValue = (imageConfig, axis) => {
    const position = imageConfig?.position;
    if (!imageConfig?.template3_position_configured) {
        return TEMPLATE3_DEFAULT_IMAGE_POSITION[axis];
    }

    const rawValue = position?.[axis];
    if (rawValue === "" || rawValue === ".") return rawValue;

    const value = Number(rawValue);
    return Number.isFinite(value) ? rawValue : TEMPLATE3_DEFAULT_IMAGE_POSITION[axis];
};

const getTemplate3FieldDefaultPosition = (fieldName, qrEnabled) => (
    TEMPLATE3_DEFAULT_FIELD_POSITIONS[qrEnabled ? "qr" : "no_qr"][fieldName]
        || { x: 0, y: 0 }
);

const getTemplate3FieldPositionValue = (fieldConfig, fieldName, axis, qrEnabled) => {
    const fallback = getTemplate3FieldDefaultPosition(fieldName, qrEnabled)[axis];
    const hasFieldPosition = Boolean(fieldConfig?.[fieldName]);
    if (!fieldConfig?.configured && !hasFieldPosition) return fallback;

    const rawValue = fieldConfig?.[fieldName]?.[axis];
    if (rawValue === "" || rawValue === ".") return rawValue;

    const value = Number(rawValue);
    return Number.isFinite(value) ? rawValue : fallback;
};

// Same encoder the print templates use; unmapped digits shown as "·" in the preview.
const PRICE_CODE_FREE_KEYS = ["prefix", "suffix"]; // accept any character, no uniqueness rule
const encodePricePreview = (sample, code = {}) => {
    const { prefix, suffix, ...rest } = code || {};
    const filled = Object.fromEntries(
        Object.entries(rest).filter(([, v]) => v)
    );
    // Mask only the encoded price, so a digit prefix/suffix isn't shown as "·".
    const inner = encodePriceWithCode(sample, filled).replace(/\d/g, "·");
    return inner ? (prefix || "") + inner + (suffix || "") : inner;
};


const BarcodePrintOutPage = () => {
    const { hash } = useLocation();
    const navigate = useNavigate();
    const { profileId: routeProfileId } = useParams();

    const [limit, setLimit] = useState(50);
    let [pageStatus, setPageStatus] = useRecoilState(pageStatusState)
    let [PageHeadingBreadCrumb, setPageHeadingBreadCrumb] = useRecoilState(pageHeadingBreadCrumbState)
    let [callerFrom, setCallerFrom] = useRecoilState(callerFromState)
    const [showImportStockIdModal, setShowImportStockIdModal] = useRecoilState(showImportStockIdModalState)
    const { t } = useTranslation();
    const [stockIdImportList, setStockIdImportList] = useState(false)
    const [selectedInventoryItems, setSelectedInventoryItems] = useRecoilState(selectedInventoryItemsState)

    const [countSelectedInventoryItem, setCountSelectedInventoryItem] = useRecoilState(countSelectedInventoryItemState)

    const [selectedInventoryId, setSelectedInventoryId] = useRecoilState(selectedInventoryIdState)
    const [currentSelectedId, setCurrentSelectedId] = useRecoilState(currentSelectedIdState)

    const iframeRef = useRef(false)

    let selectOptions = [
        { label: "please select template name", value: "" },
        {
            label: "Template-01-Barcode",
            value: "template_1"
        },
        {
            label: "Template-02-Qrcode",
            value: "template_2"
        },
        {
            label: "Template-03-RFID",
            value: "template_3"
        }


    ];

    const goToListPage = () => {
        navigate("/app/admin/setup/barcode");
        setPageStatus("list_profile_page")
        setProfileId(false)
        setPageHeadingBreadCrumb({
            heading: "Barcode Label",
            breadCrumbName: "Barcode",

        })
        setDefaultConfigData(null)
        setCheckConfigData({ config_check_list: [], config_check_info: {}, current_template_layout_selected: "", selected_options: selectOptions })
    }

    const [checkConfigData, setCheckConfigData] = useState({ config_check_list: [], config_check_info: {}, current_template_layout_selected: "", selected_options: selectOptions })
    const [defaultConfigData, setDefaultConfigData] = useState(null)


    const [configList, setConfigList] = useState();
    const [profileId, setProfileId] = useState(false)
    const [reload, setReload] = useState(false);
    const [checkedLabelIds, setCheckedLabelIds] = useState([]);
    const [, setSelectedProfileState] = useRecoilState(selectedProfileState);

    useEffect(() => {
        const defaultInventoryRequest = {
            item: [],
            collection: [],
            metal: [],
            size: [],
            stone: [],
            productStatus: [],
            location: [],
            price: [],
            search: "",
            limit: 100,
            skip: 0,
        };
        const inventoryCountRequest = {
            item: [],
            collection: [],
            metal: [],
            size: [],
            stone: [],
            productStatus: [],
            location: [],
            price: [],
            search: "",
            limit: 100,
        };
        const inventoryColumnsRequest = { name: "tbl_my_inventory" };

        Promise.all([
            inventoryQueryClient.prefetchQuery({
                queryKey: ["barcode-printout-inventory", defaultInventoryRequest],
                queryFn: () => _Api(defaultInventoryRequest, "api/v1/Inventory/my/list/search"),
            }),
            inventoryQueryClient.prefetchQuery({
                queryKey: ["barcode-printout-inventory-lower-count", inventoryCountRequest],
                queryFn: () => _Api(inventoryCountRequest, "api/v1/Inventory/my/inventory-lowerStatics"),
            }),
            inventoryQueryClient.prefetchQuery({
                queryKey: ["barcode-printout-inventory-columns", inventoryColumnsRequest],
                queryFn: () => _Api(inventoryColumnsRequest, "api/v1/Inventory/common/getColumnHeads"),
            }),
        ]).catch((err) => {
            console.log(err, "barcode inventory prefetch error");
        });
    }, []);

    const getLabelOption = (profile) => ({
        label: profile.profile_name,
        value: profile._id
    });

    const applyLastCheckedLabel = (checkedIds, list = configList) => {
        if (!list || checkedIds.length === 0) {
            setSelectedProfileState(false);
            return;
        }
        const lastId = checkedIds[checkedIds.length - 1];
        const lastLabel = list.find(v => v._id === lastId);
        if (lastLabel) {
            setSelectedProfileState(getLabelOption(lastLabel));
        }
    };

    const handleLabelCheck = (e, profile) => {
        const id = profile._id;
        if (e.target.checked) {
            const next = checkedLabelIds.includes(id) ? checkedLabelIds : [...checkedLabelIds, id];
            setCheckedLabelIds(next);
            setSelectedProfileState(getLabelOption(profile));
        } else {
            const next = checkedLabelIds.filter(x => x !== id);
            setCheckedLabelIds(next);
            applyLastCheckedLabel(next);
        }
    };

    const handleCheckAllLabels = (e) => {
        if (e.target.checked && configList?.length) {
            const allIds = configList.map(v => v._id);
            setCheckedLabelIds(allIds);
            applyLastCheckedLabel(allIds);
        } else {
            setCheckedLabelIds([]);
            setSelectedProfileState(false);
        }
    };
    const importStockIdList = async () => {

        if (stockIdImportList && stockIdImportList.trim() !== "") {
            const listImport = stockIdImportList.split("\n");
            const filteredListImport = listImport.filter(el => el !== null && el.trim() !== "");

            const newIds = filteredListImport.filter(id => !selectedInventoryId.includes(id) && !currentSelectedId.includes(id));

            if (newIds.length === 0) {
                error(t("All entered Stock IDs are already added"))
                return;
            }

            const postdata = {
                "item": [],
                "collection": [],
                "metal": [],
                "size": [],
                "stone": [],
                "productStatus": [],
                "location": [],
                "price": [],
                "search": newIds,
                "limit": 100,
                "skip": 0,
            };

            const searchImport = await _Api(postdata, "api/v1/Inventory/my/list/search/by-stock-id")
            setSelectedInventoryItems(prev => prev ? [...prev, ...searchImport.data] : [...searchImport.data])
            setCountSelectedInventoryItem(countSelectedInventoryItem + searchImport.data.length)
            setSelectedInventoryId(prev => [...prev, ...newIds])
            setCurrentSelectedId(prev => [...prev, ...newIds])
            setShowImportStockIdModal(false)
            setStockIdImportList(false)

        } else {
            error(t("Please enter at least one Stock ID"))
        }
    }
    const deleteProfileTemplate = async (_id) => {

        const deleteProfile = await _Api({ _id: _id }, "api/v1/template-printout/delete");

        if (deleteProfile) {

            setReload(!reload)
            window.location.reload(false)
        }
    }
    const cloneProfileTemplate = async (_id) => {
        if (!_id) return;

        const GetloadingID = loading();
        try {
            const cloneData = await _Api({ _id }, "api/v1/template-printout/clone");
            if (cloneData?.code === 200) {
                Updateloading(t, GetloadingID, cloneData?.message || t("Template cloned"));
                window.location.reload(false);
            } else {
                Updateloading(t, GetloadingID, cloneData?.message || t("Template not found"), "error");
            }
        } catch (err) {
            Updateloading(t, GetloadingID, t("Template not found"), "error");
        }
    }
    const loadProfile = async (_id) => {
        if (!_id) return;

        const listDataConfig = await _Api({ _id }, "api/v1/template-printout/getByid");
        if (!listDataConfig?.data) {
            console.error("Unable to load barcode profile", _id);
            return;
        }

        const savedCustomTemplateConfig = listDataConfig.data.custom_template_config_info
            || listDataConfig.data.profile_setup_info?.custom_template_config_info
            || listDataConfig.data.custom_template_config
            || null;
        const loadedTemplateValue = getSelectedTemplateValue(listDataConfig.data.current_template_layout_selected);
        const storedProfileSetup = listDataConfig.data.profile_setup_info || {};
        const storedPcsValue = storedProfileSetup.pcs
            ?? listDataConfig.data.pcs
            ?? listDataConfig.data.config_check_info?.pcs;
        const shouldShowPieceCount = storedPcsValue === undefined
            ? true
            : storedPcsValue === true
                || storedPcsValue === 1
                || storedPcsValue === "1"
                || String(storedPcsValue).toLowerCase() === "true";
        const loadedConfigList = [...(listDataConfig.data.config_check_list || [])];
        if (["template_1", "template_2", "template_3"].includes(loadedTemplateValue)
            && shouldShowPieceCount
            && !loadedConfigList.includes("pcs")) {
            loadedConfigList.push("pcs");
        }
        const loadedConfigData = cloneConfigData({
            config_check_list: loadedConfigList,
            config_check_info: {
                ...(listDataConfig.data.config_check_info || {}),
                preview_stone_count: listDataConfig.data.profile_setup_info?.preview_stone_count
                    || listDataConfig.data.config_check_info?.preview_stone_count,
                text_font_size: listDataConfig.data.profile_setup_info?.text_font_size
                    || listDataConfig.data.text_font_size
                    || listDataConfig.data.config_check_info?.text_font_size
                    || DEFAULT_TEXT_FONT_SIZE,
                image_config: listDataConfig.data.profile_setup_info?.image_config
                    || listDataConfig.data.config_check_info?.image_config
                    || null,
                text_config: listDataConfig.data.profile_setup_info?.text_config
                    || listDataConfig.data.text_config
                    || listDataConfig.data.config_check_info?.text_config
                    || null,
                template3_field_positions: listDataConfig.data.profile_setup_info?.template3_field_positions
                    || listDataConfig.data.config_check_info?.template3_field_positions
                    || null,
                normal_encode_pre_suf_fix: (({ prefix, suffix } = {}) => ({
                    prefix: String(prefix || "").replace(/\s/g, ""),
                    suffix: String(suffix || "").replace(/\s/g, ""),
                }))(listDataConfig.data.normal_encode_pre_suf_fix
                    || listDataConfig.data.config_check_info?.normal_encode_pre_suf_fix),
                _id: listDataConfig.data._id,
            },
            current_template_layout_selected: listDataConfig.data.current_template_layout_selected || "",
            custom_template_config_info: savedCustomTemplateConfig,
        });

        const savedCode = loadedConfigData.config_check_info.with_code
            || listDataConfig.data.with_code
            || {};
        loadedConfigData.config_check_info.with_code = Object.fromEntries(
            Object.entries(savedCode).map(([key, value]) => [
                key,
                PRICE_CODE_FREE_KEYS.includes(key)
                    ? String(value || "").slice(-1).toUpperCase()
                    : String(value || "").replace(/\d/g, "").slice(-1).toUpperCase(),
            ])
        );

        setDefaultConfigData(loadedConfigData)
        setCheckConfigData((prev) => ({
            ...prev,
            ...loadedConfigData,
            custom_template_config: loadedConfigData.custom_template_config,
            custom_template_config_info: loadedConfigData.custom_template_config_info,
        }))
        setProfileId(_id)
        setPageStatus("edit_profile_page")
        setPageHeadingBreadCrumb({
            heading: "Edit Barcode Label",
            breadCrumbName: "Barcode Label",
        })
    }

    const editProfile = (_id) => {
        if (!_id) return;
        navigate(`/app/admin/setup/barcode/${_id}`);
    }

    useEffect(() => {
        if (routeProfileId) {
            loadProfile(routeProfileId);
        }
        // The profile id in the URL is the source of truth for the edit page.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [routeProfileId]);

    // useEffect(()=>{
    //     const iframe = iframeRef.current;
    //     const onLoadHandler = () => {
    //         // Send a message to the iframe after it loads
    //         iframe.contentWindow.postMessage(
    //           { action: 'printcustom',
    //             payload : {

    //             }

    //            }, 
    //           'https://printprn.giscloud.co/' // Specify the iframe's exact origin
    //         );
    //       };

    //       // Attach the load event listener to ensure the iframe has fully loaded
    //       iframe.addEventListener('load', onLoadHandler);

    //       return () => {
    //         iframe.removeEventListener('load', onLoadHandler);
    //       };

    // },[])


    useEffect(() => {

        if (!profileId && !routeProfileId) {


            async function fetchData() {
                const listDataConfig = await _Api({ template_type: "barcode_printout_template" }, "api/v1/template-printout/list");


                const { data } = await listDataConfig;
                setConfigList(data)

            }

            fetchData();
        }
    }

        , [profileId, hash])






    let config = {
        "metal": true,
        "replaceMetalArea": true,

    }



    return (



        <barcodePrintOutContext.Provider value={{ checkConfigData, setCheckConfigData }}>



            <div className={`container-fluid barcode_tamplate${pageStatus === "inventory_import_page" ? " is-inventory-import" : ""}`}>
                <div className="stock_id_import_panel" style={{ display: showImportStockIdModal ? "block" : "none" }}>



                    <div className="heading_area">
                        <span class="import_heading_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 10H12.1M7.89999 10H7.99999M16 10H16.1" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M21 4V16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H13L8 21V17H4C3.73478 17 3.48043 16.8946 3.29289 16.7071C3.10536 16.5196 3 16.2652 3 16V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </span>
                        <h3>Stock ID</h3>
                        <button className="close_import_display_button" onClick={() => {
                            setShowImportStockIdModal(false)
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className="search_area">
                        <textarea className="stock_id_import_text" rows="50" value={stockIdImportList ? stockIdImportList : ""} placeholder="Type your note here." onChange={(e) => {
                            setStockIdImportList(e.target.value)
                        }} />
                        <button className="submit_impoort_stock_id"
                            onClick={() => {
                                importStockIdList(stockIdImportList)
                            }}
                        >Submit</button>
                    </div>
                </div>
                <div className="heading_breadcrumb_block">
                    <ul class="breadcrumb">

                        <li className="non_link">

                            {callerFrom == "" ? "Setup" : "Barcode"}

                            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                        </li>

                        <li className="non_link">
                            <span>Barcode</span>
                        </li>
                        {pageStatus !== "list_profile_page" ?
                            <>

                                <li onClick={goToListPage}>

                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                                    <span>Barcode Label</span>
                                    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11.5L6.5 6.5L1.5 1.5" stroke="#B3B3B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>

                                </li>
                            </>


                            : ""}

                        {pageStatus === "print_preview_page" ?

                            <li>
                                <span class="active_page">

                                    Barcode Printing
                                </span>


                            </li>

                            : ""}

                        {pageStatus === "add_profile_page" ?

                            <li >
                                <span class="active_page">

                                    Add Label

                                </span>

                            </li>

                            : ""}


                        {pageStatus === "edit_profile_page" ?

                            <li >
                                <span class="active_page">

                                    Edit Label

                                </span>

                            </li>

                            : ""}


                        {pageStatus === "inventory_import_page" ?

                            <li >
                                <span class="active_page">

                                    Add Inventory

                                </span>

                            </li>

                            : ""}


                    </ul>

                    {pageStatus !== "print_preview_page" && pageStatus !== "print_preview_page" ?
                        // <h1>
                        //     {PageHeadingBreadCrumb.heading}
                        // </h1>
                        ""
                        : ""}

                    {pageStatus == "list_profile_page" ?
                        <button className="add_barcode_label"
                            onClick={() => {
                                setPageStatus("add_profile_page")
                                setProfileId(false)
                                setDefaultConfigData(null)
                                setCheckConfigData((prev) => ({
                                    ...prev,
                                    config_check_list: [],
                                    config_check_info: {},
                                    current_template_layout_selected: "",
                                }))
                                setPageHeadingBreadCrumb({
                                    heading: "Add Label Profile ",
                                    breadCrumbName: "Add Label ",

                                })
                                window.location.href = "#add_profile_page";


                            }
                            }
                        >+ Add Label</button>
                        : ""}
                    <div id="barcode-heading-actions" className="heading_breadcrumb_block-actions" />


                </div>





                {
                    pageStatus === "add_profile_page" || pageStatus === "edit_profile_page" ?

                        <div className="config_panel_wrapper barcode_profile_config_panel_wrapper">
                            <div className="config_panel_block">

                                <ConfigPanel
                                    key={profileId || "new-profile"}
                                    profileId={profileId}
                                    defaultConfigData={defaultConfigData}
                                    setDefaultConfigData={setDefaultConfigData}
                                />

                            </div>

                        </div>
                        : ""

                }



                {
                    pageStatus === "list_profile_page" ?


                        <>
                            <div className="profile_print_out_content_block">
                                <div className="top_bar_menu_table">
                                    <div className="limit_block">
                                        <Select
                                            className="limit-select limit_profile_select short"
                                            options={selectLimitOptions}
                                            value={{ label: limit, value: limit }}

                                        />
                                    </div>
                                    <div className="search_find_import">
                                        <span className="search_icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M16.927 17.0401L20.4001 20.4001M19.2801 11.4401C19.2801 15.77 15.77 19.2801 11.4401 19.2801C7.11019 19.2801 3.6001 15.77 3.6001 11.4401C3.6001 7.11019 7.11019 3.6001 11.4401 3.6001C15.77 3.6001 19.2801 7.11019 19.2801 11.4401Z" stroke="#A4A4A4" stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span className="print_icon">

                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clipPath="url(#clip0_6663_33341)">
                                                    <path d="M18.75 17H20C20.5523 17 21 16.5523 21 16V8C21 7.44772 20.5523 7 20 7H4C3.44772 7 3 7.44772 3 8V16C3 16.5523 3.44772 17 4 17H5.25" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12V20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20V12Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6 4C6 3.44772 6.44772 3 7 3H17C17.5523 3 18 3.44772 18 4V7H6V4Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 13.5H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 18.5H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.5 16H15.5" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6663_33341">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <span className="barcode_print" onClick={
                                            () => {
                                                setPageStatus("print_preview_page")
                                                setPageHeadingBreadCrumb({
                                                    heading: "Barcode Printing",
                                                    breadCrumbName: "Barcode Printing",

                                                })
                                                window.location.href = "#print_preview_page";

                                            }
                                        }>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <mask id="path-1-inside-1_6663_16757" fill="white">
                                                    <path d="M3 18.9608H3.58575V5.03857H3V18.9608ZM4.758 18.9608H5.90625V5.03857H4.758V18.9608ZM7.0545 18.9608H8.22675V5.03857H7.0545V18.9608ZM9.375 18.9608H11.7188V5.03857H9.375V18.9608ZM12.867 18.9608H14.625V5.03857H12.867V18.9608ZM15.7733 18.9608H16.9455V5.03857H15.7733V18.9608ZM18.0938 18.9608H18.6795V5.03857H18.0938V18.9608ZM19.8517 18.9608H21V5.03857H19.8517V18.9608Z" />
                                                </mask>
                                                <path d="M3 18.9608H3.58575V5.03857H3V18.9608ZM4.758 18.9608H5.90625V5.03857H4.758V18.9608ZM7.0545 18.9608H8.22675V5.03857H7.0545V18.9608ZM9.375 18.9608H11.7188V5.03857H9.375V18.9608ZM12.867 18.9608H14.625V5.03857H12.867V18.9608ZM15.7733 18.9608H16.9455V5.03857H15.7733V18.9608ZM18.0938 18.9608H18.6795V5.03857H18.0938V18.9608ZM19.8517 18.9608H21V5.03857H19.8517V18.9608Z" fill="#A4A4A4" />
                                                <path d="M3 18.9608H-22V43.9608H3V18.9608ZM3.58575 18.9608V43.9608H28.5858V18.9608H3.58575ZM3.58575 5.03857H28.5858V-19.9614H3.58575V5.03857ZM3 5.03857V-19.9614H-22V5.03857H3ZM4.758 18.9608H-20.242V43.9608H4.758V18.9608ZM5.90625 18.9608V43.9608H30.9062V18.9608H5.90625ZM5.90625 5.03857H30.9062V-19.9614H5.90625V5.03857ZM4.758 5.03857V-19.9614H-20.242V5.03857H4.758ZM7.0545 18.9608H-17.9455V43.9608H7.0545V18.9608ZM8.22675 18.9608V43.9608H33.2267V18.9608H8.22675ZM8.22675 5.03857H33.2267V-19.9614H8.22675V5.03857ZM7.0545 5.03857V-19.9614H-17.9455V5.03857H7.0545ZM9.375 18.9608H-15.625V43.9608H9.375V18.9608ZM11.7188 18.9608V43.9608H36.7188V18.9608H11.7188ZM11.7188 5.03857H36.7188V-19.9614H11.7188V5.03857ZM9.375 5.03857V-19.9614H-15.625V5.03857H9.375ZM12.867 18.9608H-12.133V43.9608H12.867V18.9608ZM14.625 18.9608V43.9608H39.625V18.9608H14.625ZM14.625 5.03857H39.625V-19.9614H14.625V5.03857ZM12.867 5.03857V-19.9614H-12.133V5.03857H12.867ZM15.7733 18.9608H-9.22675V43.9608H15.7733V18.9608ZM16.9455 18.9608V43.9608H41.9455V18.9608H16.9455ZM16.9455 5.03857H41.9455V-19.9614H16.9455V5.03857ZM15.7733 5.03857V-19.9614H-9.22675V5.03857H15.7733ZM18.0938 18.9608H-6.90625V43.9608H18.0938V18.9608ZM18.6795 18.9608V43.9608H43.6795V18.9608H18.6795ZM18.6795 5.03857H43.6795V-19.9614H18.6795V5.03857ZM18.0938 5.03857V-19.9614H-6.90625V5.03857H18.0938ZM19.8517 18.9608H-5.14825V43.9608H19.8517V18.9608ZM21 18.9608V43.9608H46V18.9608H21ZM21 5.03857H46V-19.9614H21V5.03857ZM19.8517 5.03857V-19.9614H-5.14825V5.03857H19.8517ZM3 43.9608H3.58575V-6.03918H3V43.9608ZM28.5858 18.9608V5.03857H-21.4142V18.9608H28.5858ZM3.58575 -19.9614H3V30.0386H3.58575V-19.9614ZM-22 5.03857V18.9608H28V5.03857H-22ZM4.758 43.9608H5.90625V-6.03918H4.758V43.9608ZM30.9062 18.9608V5.03857H-19.0938V18.9608H30.9062ZM5.90625 -19.9614H4.758V30.0386H5.90625V-19.9614ZM-20.242 5.03857V18.9608H29.758V5.03857H-20.242ZM7.0545 43.9608H8.22675V-6.03918H7.0545V43.9608ZM33.2267 18.9608V5.03857H-16.7733V18.9608H33.2267ZM8.22675 -19.9614H7.0545V30.0386H8.22675V-19.9614ZM-17.9455 5.03857V18.9608H32.0545V5.03857H-17.9455ZM9.375 43.9608H11.7188V-6.03918H9.375V43.9608ZM36.7188 18.9608V5.03857H-13.2812V18.9608H36.7188ZM11.7188 -19.9614H9.375V30.0386H11.7188V-19.9614ZM-15.625 5.03857V18.9608H34.375V5.03857H-15.625ZM12.867 43.9608H14.625V-6.03918H12.867V43.9608ZM39.625 18.9608V5.03857H-10.375V18.9608H39.625ZM14.625 -19.9614H12.867V30.0386H14.625V-19.9614ZM-12.133 5.03857V18.9608H37.867V5.03857H-12.133ZM15.7733 43.9608H16.9455V-6.03918H15.7733V43.9608ZM41.9455 18.9608V5.03857H-8.0545V18.9608H41.9455ZM16.9455 -19.9614H15.7733V30.0386H16.9455V-19.9614ZM-9.22675 5.03857V18.9608H40.7733V5.03857H-9.22675ZM18.0938 43.9608H18.6795V-6.03918H18.0938V43.9608ZM43.6795 18.9608V5.03857H-6.3205V18.9608H43.6795ZM18.6795 -19.9614H18.0938V30.0386H18.6795V-19.9614ZM-6.90625 5.03857V18.9608H43.0938V5.03857H-6.90625ZM19.8517 43.9608H21V-6.03918H19.8517V43.9608ZM46 18.9608V5.03857H-4V18.9608H46ZM21 -19.9614H19.8517V30.0386H21V-19.9614ZM-5.14825 5.03857V18.9608H44.8517V5.03857H-5.14825Z" fill="#A4A4A4" mask="url(#path-1-inside-1_6663_16757)" />
                                            </svg>

                                        </span>
                                    </div>
                                </div>
                                <div className="profile_list_table_block">
                                    <table className="com-custom-table-tag table align-middle profile_list_table">


                                        <thead>
                                            <tr className="text-nowrap align-middle">
                                                <th>
                                                    <div className="com-check">
                                                        <input
                                                            id="check1"
                                                            type="checkbox"
                                                            checked={Boolean(configList?.length) && checkedLabelIds.length === configList.length}
                                                            onChange={handleCheckAllLabels}
                                                        />
                                                        <label htmlFor="check1" className="com-check-label" />
                                                    </div>



                                                </th>
                                                <th># </th>
                                                <th>Profile Name </th>
                                                <th>Created Date </th>
                                                <th>Modified Date </th>
                                                <th>Template Type</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {configList ? configList.map((v, k) => (
                                                <tr className="text-nowrap align-middle" key={k}>
                                                    <td>

                                                        <div class="com-check">
                                                            <input
                                                                id={v._id}
                                                                key={k}
                                                                type="checkbox"
                                                                checked={checkedLabelIds.includes(v._id)}
                                                                onChange={(e) => handleLabelCheck(e, v)}
                                                            />
                                                            <label htmlFor={v._id} class="com-check-label"></label>
                                                        </div>
                                                    </td>
                                                    <td>{k + 1}</td>
                                                    <td>
                                                        <span className="profile_link" onClick={() => editProfile(v._id)}>

                                                            {v.profile_name}

                                                        </span>

                                                    </td>
                                                    <td>{
                                                        new Date(v.createdAt).toLocaleString('en-TH-u-ca-gregory', {
                                                            day: '2-digit',

                                                            month: '2-digit',
                                                            year: 'numeric',
                                                        })}</td>
                                                    <td>{
                                                        new Date(v.updatedAt).toLocaleString('en-TH-u-ca-gregory', {
                                                            day: '2-digit',

                                                            month: '2-digit',
                                                            year: 'numeric',
                                                        })}</td>
                                                    <td>
                                                     

{printTemplateType(v.template_layout)}
                                                    </td>

                                                    <td>
                                                       {v.template_layout!=="custom_template_01"&&v.template_layout!=="custom_template_02"?
                                                       <>
                                                        <span className="action_printout" onClick={() => editProfile(v._id)}>
                                                            <svg className="edit_icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                                <path d="M19 15V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H7" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M11.5 14.8L21 5.2L16.8 1L7.3 10.5L7 15L11.5 14.8Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </span>
                                                        <span className="action_printout view_printout_profile">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M22 12.0002C20.2531 15.5764 15.8775 19 11.9998 19C8.12201 19 3.74646 15.5764 2 11.9998" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M22 12.0002C20.2531 8.42398 15.8782 5 12.0005 5C8.1227 5 3.74646 8.42314 2 11.9998" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </span>
                                                         <span
                                                             className="action_printout clone_printout_profile"
                                                             onClick={() => cloneProfileTemplate(v._id)}
                                                             title={t("Clone profile")}
                                                             aria-label={t("Clone profile")}
                                                         >
                                                             <FiCopy size={20} color="#A4A4A4" aria-hidden="true" />
                                                         </span>



                                                        <span className="action_printout remove_printout_profile" onClick={() => {
                                                            if (window.confirm("Do you want to remove this item?")) {
                                                                deleteProfileTemplate(v._id)

                                                            }
                                                        }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M20.25 4.6875H16.3125V3.75C16.3125 3.20299 16.0952 2.67839 15.7084 2.29159C15.3216 1.9048 14.797 1.6875 14.25 1.6875H9.75C9.20299 1.6875 8.67839 1.9048 8.29159 2.29159C7.9048 2.67839 7.6875 3.20299 7.6875 3.75V4.6875H3.75C3.60082 4.6875 3.45774 4.74676 3.35225 4.85225C3.24676 4.95774 3.1875 5.10082 3.1875 5.25C3.1875 5.39918 3.24676 5.54226 3.35225 5.64775C3.45774 5.75324 3.60082 5.8125 3.75 5.8125H4.6875V19.5C4.6875 19.8481 4.82578 20.1819 5.07192 20.4281C5.31806 20.6742 5.6519 20.8125 6 20.8125H18C18.3481 20.8125 18.6819 20.6742 18.9281 20.4281C19.1742 20.1819 19.3125 19.8481 19.3125 19.5V5.8125H20.25C20.3992 5.8125 20.5423 5.75324 20.6477 5.64775C20.7532 5.54226 20.8125 5.39918 20.8125 5.25C20.8125 5.10082 20.7532 4.95774 20.6477 4.85225C20.5423 4.74676 20.3992 4.6875 20.25 4.6875ZM8.8125 3.75C8.8125 3.50136 8.91127 3.2629 9.08709 3.08709C9.2629 2.91127 9.50136 2.8125 9.75 2.8125H14.25C14.4986 2.8125 14.7371 2.91127 14.9129 3.08709C15.0887 3.2629 15.1875 3.50136 15.1875 3.75V4.6875H8.8125V3.75ZM18.1875 19.5C18.1875 19.5497 18.1677 19.5974 18.1326 19.6326C18.0974 19.6677 18.0497 19.6875 18 19.6875H6C5.95027 19.6875 5.90258 19.6677 5.86742 19.6326C5.83225 19.5974 5.8125 19.5497 5.8125 19.5V5.8125H18.1875V19.5ZM10.3125 9.75V15.75C10.3125 15.8992 10.2532 16.0423 10.1477 16.1477C10.0423 16.2532 9.89918 16.3125 9.75 16.3125C9.60082 16.3125 9.45774 16.2532 9.35225 16.1477C9.24676 16.0423 9.1875 15.8992 9.1875 15.75V9.75C9.1875 9.60082 9.24676 9.45774 9.35225 9.35225C9.45774 9.24676 9.60082 9.1875 9.75 9.1875C9.89918 9.1875 10.0423 9.24676 10.1477 9.35225C10.2532 9.45774 10.3125 9.60082 10.3125 9.75ZM14.8125 9.75V15.75C14.8125 15.8992 14.7532 16.0423 14.6477 16.1477C14.5423 16.2532 14.3992 16.3125 14.25 16.3125C14.1008 16.3125 13.9577 16.2532 13.8523 16.1477C13.7468 16.0423 13.6875 15.8992 13.6875 15.75V9.75C13.6875 9.60082 13.7468 9.45774 13.8523 9.35225C13.9577 9.24676 14.1008 9.1875 14.25 9.1875C14.3992 9.1875 14.5423 9.24676 14.6477 9.35225C14.7532 9.45774 14.8125 9.60082 14.8125 9.75Z" fill="#FF5757" />
                                                            </svg>

                                                        </span>
                                                       </>
                                                    

:""}

                                                    </td>
                                                </tr>
                                            ))
                                                : ""}
                                        </tbody>
                                    </table>
                                </div>

                            </div>


                        </>
                        : ""
                }






            {pageStatus === "inventory_import_page" ?
                <InventorySelectToPrintout />

                : ""}

            </div>

            {pageStatus == "print_preview_page" ?
                <PrintPreview />
                : ""}



        </barcodePrintOutContext.Provider>

    )
}

const ConfigPanel = ({ profileId, defaultConfigData, setDefaultConfigData }) => {
    let [pageStatus, setPageStatus] = useRecoilState(pageStatusState)

    let profileNameRef = useRef(null)
    let templateSelectionRef = useRef(null)

    const { t } = useTranslation();


    const [update, setUpdate] = useState(false);
    const [priceCodePreviewValue, setPriceCodePreviewValue] = useState(PRICE_CODE_SAMPLE);
    const { checkConfigData, setCheckConfigData } = useContext(barcodePrintOutContext)
    const [selectedInventoryItems] = useRecoilState(selectedInventoryItemsState)
    const [previewResetKey, setPreviewResetKey] = useState(0);

    const selectTemplatePrintout = (e) => {

        let val = { "label": e.label, "value": e.value };
        setCurrentSelectTemplate(val);
        const templateDefaultData = getTemplateDefaultData(e.value);
        const isEditingProfile = Boolean(checkConfigData.config_check_info?._id);

        if (!isEditingProfile) {
            setDefaultConfigData(templateDefaultData);
        }

        setCheckConfigData((prev) => {
            const nextInfo = { ...templateDefaultData.config_check_info };
            if (prev.config_check_info?.profile_name) {
                nextInfo.profile_name = prev.config_check_info.profile_name;
            }

            return {
                ...prev,
                config_check_list: [...templateDefaultData.config_check_list],
                config_check_info: nextInfo,
                current_template_layout_selected: val,
            };
        })
        setUpdate((value) => !value)
    }
    let newobj = {
        config_check_list: [],
        config_check_info: {},
        current_template_layout_selected: "",
        selected_options: ""
    }



    let [currentSelectTemplate, setCurrentSelectTemplate] = useState(checkConfigData.current_template_layout_selected);

    useEffect(() => {
        setCurrentSelectTemplate(checkConfigData.current_template_layout_selected || "");
    }, [checkConfigData.current_template_layout_selected?.value, checkConfigData.current_template_layout_selected]);


    const checkDependStoreLocation = (e) => {


        // setCheckConfigData((prev)=>{
        //     prevState= prev
        // let obj = prevState;
        // if(Object.keys(prev).length>0){

        //     obj.config_check_info.qr_url_depend_location = e.target.checked

        //     console.log(obj,'newobj if')
        //     setUpdate(!update)

        //     return obj;
        // }

        //     })


    }

    const checkConfig = (e) => {

        const currentCheck = checkConfigData.config_check_list ? checkConfigData.config_check_list : [];

        if (e.target.value != "") {
            let prevState;
            if (e.target.checked === true) {
                //config_data:[...checkConfigDataContext,e.target.value],} config_check_list 
                //{config_check_list:[],config_check_info:{}}
                // { 

                setCheckConfigData((prev) => {
                    prevState = prev
                    let obj = prevState;
                    if (Object.keys(prev).length > 0) {
                        obj.config_check_list.push(e.target.value)
                        setUpdate(!update)

                        return obj;
                    } else {
                        obj.config_check_list.push(e.target.value)

                        setUpdate(!update)

                        return obj
                    }

                })


            } else {

                let filtered = currentCheck.filter(function (item) {
                    return item != e.target.value
                })




                setCheckConfigData((prev) => {
                    prevState = prev
                    let obj = prevState;

                    obj.config_check_list.splice(0, obj.config_check_list.length);
                    obj.config_check_list.push(...filtered)
                    setUpdate(!update)

                    return obj

                })

            }
        }

    }

    const changeInputWithFieldName = (e, field_name) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.config_check_info = obj.config_check_info || {};
            obj.config_check_info[field_name] = e.target.value;
            setUpdate(!update)
            return obj;
        })

    }

    const changeNumericInputWithFieldName = (e, field_name) => {
        const rawValue = e.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                [field_name]: rawValue,
            },
        }));
    };

    const changeSelectWithFieldName = (e, field_name) => {
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.config_check_info = obj.config_check_info || {};
            obj.config_check_info[field_name] = e.value;
            setUpdate(!update)
            return obj;
        })

    }

    const changeImage = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
            const imageConfig = await prepareBarcodeImage(file);
            setCheckConfigData((prev) => ({
                ...prev,
                config_check_info: {
                    ...(prev.config_check_info || {}),
                    image_config: imageConfig,
                },
            }));
            setUpdate((value) => !value);
        } catch (conversionError) {
            error(conversionError.message || "Unable to prepare image");
            event.target.value = "";
        }
    };

    const changeImageSize = (event, dimension) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: {
                    ...(prev.config_check_info?.image_config || {}),
                    size: {
                        ...(prev.config_check_info?.image_config?.size || {}),
                        [dimension]: rawValue,
                    },
                },
            },
        }));
    };

    const changeImageScale = (event) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: {
                    ...(prev.config_check_info?.image_config || {}),
                    scale: rawValue,
                },
            },
        }));
    };

    const priceAffixPrefixRef = useRef(null);
    const priceAffixSuffixRef = useRef(null);
    const handlePriceAffixKeyDown = (e, field) => {
        if (/^\s$/.test(e.key)) {
            e.preventDefault();
            return;
        }
        // Backspace on an already empty Suffix steps back to the end of Prefix.
        if (field === "suffix" && e.key === "Backspace" && !e.currentTarget.value) {
            e.preventDefault();
            const prefixInput = priceAffixPrefixRef.current;
            if (prefixInput) {
                prefixInput.focus();
                const end = prefixInput.value.length;
                prefixInput.setSelectionRange(end, end);
            }
        }
    };

    const changeNormalPriceAffix = (field, value) => {
        const text = String(value || "").replace(/\s/g, "");

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                normal_encode_pre_suf_fix: {
                    ...(prev.config_check_info?.normal_encode_pre_suf_fix || {}),
                    [field]: text,
                },
            },
        }));
    };

    const changeImagePosition = (event, axis) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: {
                    ...(prev.config_check_info?.image_config || {}),
                    template3_position_configured: true,
                    position: {
                        x: getTemplate3ImagePositionValue(prev.config_check_info?.image_config, "x"),
                        y: getTemplate3ImagePositionValue(prev.config_check_info?.image_config, "y"),
                        [axis]: rawValue,
                    },
                },
            },
        }));
    };

    const changeTextPosition = (event, axis) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                text_config: {
                    ...(prev.config_check_info?.text_config || {}),
                    position: {
                        ...(prev.config_check_info?.text_config?.position || {}),
                        [axis]: rawValue,
                    },
                },
            },
        }));
    };

    const changeTemplate3FieldPosition = (event, fieldName, axis) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                template3_field_positions: {
                    ...(prev.config_check_info?.template3_field_positions || {}),
                    configured: true,
                    [fieldName]: {
                        ...(prev.config_check_info?.template3_field_positions?.[fieldName] || {}),
                        [axis]: rawValue,
                    },
                },
            },
        }));
    };

    const changeTemplate3FieldSize = (event, fieldName) => {
        const rawValue = event.target.value;
        if (!isEditableNumericValue(rawValue)) return;

        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                template3_field_positions: {
                    ...(prev.config_check_info?.template3_field_positions || {}),
                    configured: true,
                    [fieldName]: {
                        ...(prev.config_check_info?.template3_field_positions?.[fieldName] || {}),
                        size: rawValue,
                    },
                },
            },
        }));
    };

    const getTemplate3LockReferenceText = (fieldName) => {
        const item = selectedInventoryItems?.[0] || {};
        const config = checkConfigData.config_check_info || {};

        if (fieldName === "sku") return String(item.SKU || "SB03218KYGDM-45");
        if (fieldName === "stock_id") return String(item.stock_id || "100");
        if (fieldName === "metal") return String(item.metal_code || "18KYG").substring(0, 5);
        if (fieldName === "weight") {
            const rawWeight = config.weight_display === "gwt" ? item.GrossWt : item.NetWt;
            const weight = formatWeightValue(
                rawWeight === undefined || rawWeight === null || rawWeight === ""
                    ? "5.00"
                    : rawWeight,
            );
            return `${weight}g`;
        }
        if (fieldName === "pcs") return "3p";
        if (fieldName === "price") {
            const rawPrice = item.price ?? item.retailprice_Inc ?? "31800.00";
            const numericPrice = String(rawPrice).replace(/[^0-9.]/g, "");
            const formattedPrice = numericPrice
                ? Number(numericPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : String(rawPrice);
            if (config.price_display === "with_currency") {
                return `${item.currency || ""} ${formattedPrice.replace(/\.\d*/, "")}`.trim();
            }
            if (config.price_display === "with_code") {
                return encodePriceWithCode(formattedPrice, config.with_code || {});
            }
            return formattedPrice.replace(/\.\d*/, "");
        }
        if (fieldName === "text") {
            return String(config.text_message || "");
        }

        return "";
    };

    const toggleTemplate3FieldPositionLock = (fieldName) => {
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                template3_field_positions: {
                    ...(prev.config_check_info?.template3_field_positions || {}),
                    configured: true,
                    [fieldName]: {
                        ...(prev.config_check_info?.template3_field_positions?.[fieldName] || {}),
                        ...(() => {
                            const currentPosition = prev.config_check_info?.template3_field_positions?.[fieldName] || {};
                            const defaultPosition = getTemplate3FieldDefaultPosition(
                                fieldName,
                                prev.config_check_list?.includes("qr"),
                            );
                            const nextLocked = !currentPosition.position_locked;

                            return {
                                x: currentPosition.x === undefined || currentPosition.x === ""
                                    ? defaultPosition.x
                                    : currentPosition.x,
                                y: currentPosition.y === undefined || currentPosition.y === ""
                                    ? defaultPosition.y
                                    : currentPosition.y,
                                position_locked: nextLocked,
                                lock_reference_text: nextLocked
                                    ? getTemplate3LockReferenceText(fieldName)
                                    : currentPosition.lock_reference_text,
                            };
                        })(),
                    },
                },
            },
        }));
    };

    const toggleImagePositionLock = () => {
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                image_config: {
                    ...(prev.config_check_info?.image_config || {}),
                    position_locked: !prev.config_check_info?.image_config?.position_locked,
                },
            },
        }));
    };

    const toggleTextPositionLock = () => {
        setCheckConfigData((prev) => ({
            ...prev,
            config_check_info: {
                ...(prev.config_check_info || {}),
                text_config: {
                    ...(prev.config_check_info?.text_config || {}),
                    position_locked: !prev.config_check_info?.text_config?.position_locked,
                    lock_reference_text: !prev.config_check_info?.text_config?.position_locked
                        ? getTemplate3LockReferenceText("text")
                        : prev.config_check_info?.text_config?.lock_reference_text,
                },
            },
        }));
    };

    const priceCodeInputRefs = useRef({});

    const focusPriceCodeInput = (key, step) => {
        const order = PRICE_CODE_FIELDS.map((f) => f.key);
        const next = order[order.indexOf(key) + step];
        if (next && priceCodeInputRefs.current[next]) {
            priceCodeInputRefs.current[next].focus();
            priceCodeInputRefs.current[next].select();
        }
    }

    const changePriceCodeChar = (key, rawValue) => {
        const isFreeKey = PRICE_CODE_FREE_KEYS.includes(key);
        // Code characters: letters/symbols only, since digits would defeat the purpose of a price code.
        const char = isFreeKey
            ? String(rawValue || "").slice(-1).toUpperCase()
            : String(rawValue || "").replace(/\d/g, "").slice(-1).toUpperCase();
        if (char && !isFreeKey) {
            const current = checkConfigData.config_check_info.with_code || {};
            const usedBy = Object.keys(current).find(
                (k) => k !== key && !PRICE_CODE_FREE_KEYS.includes(k) && current[k] && current[k].toUpperCase() === char.toUpperCase()
            );
            if (usedBy) {
                const usedLabel = PRICE_CODE_FIELDS.find((f) => f.key === usedBy)?.label || usedBy;
                error(t("Character already used for") + " " + t(usedLabel));
                return;
            }
        }
        setCheckConfigData((prev) => {
            let obj = prev;
            obj.config_check_info = obj.config_check_info || {};
            obj.config_check_info.with_code = {
                ...(obj.config_check_info.with_code || {}),
                [key]: char,
            };
            setUpdate(!update);
            return obj;
        });
        if (char) {
            focusPriceCodeInput(key, 1);
        }
    }

    const handlePriceCodeKeyDown = (e, key) => {
        if (/^\d$/.test(e.key) && !PRICE_CODE_FREE_KEYS.includes(key)) {
            e.preventDefault();
            return;
        }
        if (e.key === "Backspace" && !e.currentTarget.value) {
            e.preventDefault();
            focusPriceCodeInput(key, -1);
        } else if (e.key === "ArrowRight") {
            focusPriceCodeInput(key, 1);
        } else if (e.key === "ArrowLeft") {
            focusPriceCodeInput(key, -1);
        }
    }

    const handlePriceCodePreviewChange = (rawValue) => {
        setPriceCodePreviewValue(String(rawValue || "").replace(/[^\d.,]/g, ""));
    };

    const handlePriceCodePreviewKeyDown = (e) => {
        const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];
        if (allowed.includes(e.key) || /[\d.,]/.test(e.key)) {
            return;
        }
        e.preventDefault();
    };

    const renderPriceCodeInput = (field) => {
        const value = checkConfigData.config_check_info.with_code?.[field.key] || "";
        return (
            <input
                id={`price_code_${field.key}`}
                ref={(el) => { priceCodeInputRefs.current[field.key] = el; }}
                className={`price_code_field-input${value ? " is-filled" : ""}`}
                type="text"
                maxLength={1}
                autoComplete="off"
                inputMode="text"
                value={value}
                onChange={(e) => changePriceCodeChar(field.key, e.target.value)}
                onKeyDown={(e) => handlePriceCodeKeyDown(e, field.key)}
                onFocus={(e) => e.target.select()}
            />
        );
    }

    const renderTemplate3FieldPositionControls = (fieldName, label, hasSize = false) => {
        if (selectedTemplateValue !== "template_3") return null;

        const qrEnabled = checkConfigData.config_check_list.includes("qr");
        const fieldPosition = checkConfigData.config_check_info?.template3_field_positions?.[fieldName];
        const controlId = `template3_${fieldName}`;

        return (
            <div className="barcode_template3_inline_position_controls">
                <span className="barcode_template3_inline_position_label">{label}</span>
                <div className="barcode_template3_inline_position_row">
                    <label htmlFor={`${controlId}_x`}>X</label>
                    <input
                        id={`${controlId}_x`}
                        type="text"
                        inputMode="decimal"
                        min="0"
                        max="70"
                        step="0.1"
                        value={getTemplate3FieldPositionValue(
                            checkConfigData.config_check_info?.template3_field_positions,
                            fieldName,
                            "x",
                            qrEnabled,
                        )}
                        onChange={(event) => changeTemplate3FieldPosition(event, fieldName, "x")}
                    />
                    <label htmlFor={`${controlId}_y`}>Y</label>
                    <input
                        id={`${controlId}_y`}
                        type="text"
                        inputMode="decimal"
                        min="0"
                        max="30"
                        step="0.1"
                        value={getTemplate3FieldPositionValue(
                            checkConfigData.config_check_info?.template3_field_positions,
                            fieldName,
                            "y",
                            qrEnabled,
                        )}
                        onChange={(event) => changeTemplate3FieldPosition(event, fieldName, "y")}
                    />
                    {hasSize ? (
                        <>
                            <label htmlFor={`${controlId}_size`}>Size</label>
                            <input
                                id={`${controlId}_size`}
                                type="text"
                                inputMode="numeric"
                                min="1"
                                max="100"
                                step="1"
                                value={getTemplate3FieldPositionValue(
                                    checkConfigData.config_check_info?.template3_field_positions,
                                    fieldName,
                                    "size",
                                    qrEnabled,
                                )}
                                onChange={(event) => changeTemplate3FieldSize(event, fieldName)}
                            />
                        </>
                    ) : null}
                    <button
                        type="button"
                        className={`barcode_template3_lock_button${fieldPosition?.position_locked ? " is-locked" : ""}`}
                        title={fieldPosition?.position_locked ? `Unlock ${label} position` : `Lock ${label} position`}
                        aria-label={fieldPosition?.position_locked ? `Unlock ${label} position` : `Lock ${label} position`}
                        onClick={() => toggleTemplate3FieldPositionLock(fieldName)}
                    >
                        {fieldPosition?.position_locked
                            ? <FiLock aria-hidden="true" />
                            : <FiUnlock aria-hidden="true" />}
                    </button>
                </div>
            </div>
        );
    };




    const checkListToObject = (data) => {
        const { template, checkList } = data;
        const templateConfig = getTemplateConfigByValue(template) || {};

        let conf = {}
        Object.keys(templateConfig).map((v, k) => {
            conf[v] = checkList.includes(v)
        })
        return conf
    }

    const resetToDefault = () => {
        const fallbackDefaultData = selectedTemplateValue
            ? getTemplateDefaultData(selectedTemplateValue)
            : null;
        const resetData = cloneConfigData(defaultConfigData || fallbackDefaultData);
        if (!resetData.current_template_layout_selected) return;

        if (!defaultConfigData && checkConfigData.config_check_info?.profile_name) {
            resetData.config_check_info.profile_name = checkConfigData.config_check_info.profile_name;
        }

        setCheckConfigData((prev) => ({ ...prev, ...resetData }));
        setPreviewResetKey((value) => value + 1);
        setUpdate((value) => !value);
    };

    const saveProfile = async (configData) => {
        const { config_check_info, config_check_list, current_template_layout_selected } = configData.profile_config;
        const { t } = configData;
        const templateConfigData = checkListToObject({ template: current_template_layout_selected.value, checkList: config_check_list })
        const previewStoneCount = Number(config_check_info.preview_stone_count);
        if (Number.isFinite(previewStoneCount) && previewStoneCount > 0) {
            templateConfigData.preview_stone_count = Math.min(5, Math.max(1, Math.floor(previewStoneCount)));
        }
        templateConfigData.text_message = config_check_info.text_message || "";
        templateConfigData.text_font_size = normalizeTextFontSize(config_check_info.text_font_size);
        templateConfigData.text_config = config_check_info.text_config || null;
        templateConfigData.image_config = config_check_info.image_config || null;
        templateConfigData.template3_field_positions = config_check_info.template3_field_positions || null;
        const customTemplateConfigInfo = configData.profile_config.custom_template_config;

        const payload = {
            profile_name: config_check_info.profile_name,
            barcode_display: config_check_info.barcode_display,
            weight_display: config_check_info.weight_display,
            price_display: config_check_info.price_display,
            qr_type_display: config_check_info.qr_type_display,
            qr_url_display: config_check_info.qr_url_display,
            qr_url_depend_location: config_check_info.qr_url_depend_location,
            text_message: config_check_info.text_message,
            text_font_size: templateConfigData.text_font_size,
            text_config: templateConfigData.text_config,
            image_config: templateConfigData.image_config,
            template3_field_positions: templateConfigData.template3_field_positions,
            with_code: config_check_info.with_code,
            normal_encode_pre_suf_fix: config_check_info.normal_encode_pre_suf_fix || { prefix: "", suffix: "" },
            profile_setup_info: templateConfigData,
            ...(customTemplateConfigInfo ? { custom_template_config_info: customTemplateConfigInfo } : {}),
            template_type: "barcode_printout_template",
            template_layout: current_template_layout_selected.value
        }

        const createData = await _Api(payload, 'api/v1/template-printout/create')
        if (createData) {
            let GetloadingID = loading();

            Updateloading(t, GetloadingID, t("Successfully Add Printing Layout"));
            setUpdate(!update)
            window.location.reload(false)
        } else {

        }
    }
    const updateProfile = async (configData) => {
        let payload;
        const { config_check_info, config_check_list, current_template_layout_selected } = configData.profile_config;
        const { t } = configData;
        const templateConfigData = checkListToObject({ template: current_template_layout_selected.value, checkList: config_check_list })
        const previewStoneCount = Number(config_check_info.preview_stone_count);
        if (Number.isFinite(previewStoneCount) && previewStoneCount > 0) {
            templateConfigData.preview_stone_count = Math.min(5, Math.max(1, Math.floor(previewStoneCount)));
        }
        templateConfigData.text_message = config_check_info.text_message || "";
        templateConfigData.text_font_size = normalizeTextFontSize(config_check_info.text_font_size);
        templateConfigData.text_config = config_check_info.text_config || null;
        templateConfigData.image_config = config_check_info.image_config || null;
        templateConfigData.template3_field_positions = config_check_info.template3_field_positions || null;
        const customTemplateConfigInfo = configData.profile_config.custom_template_config;
        if (typeof config_check_info.qr_type_display == "undefined") {
            payload = {
                _id: config_check_info._id,
                profile_name: config_check_info.profile_name,
                barcode_display: config_check_info.barcode_display,
                weight_display: config_check_info.weight_display,
                price_display: config_check_info.price_display,
                text_message: config_check_info.text_message,
                text_font_size: templateConfigData.text_font_size,
                text_config: templateConfigData.text_config,
                image_config: templateConfigData.image_config,
                template3_field_positions: templateConfigData.template3_field_positions,
                with_code: config_check_info.with_code,
                normal_encode_pre_suf_fix: config_check_info.normal_encode_pre_suf_fix || { prefix: "", suffix: "" },
                profile_setup_info: templateConfigData,
                ...(customTemplateConfigInfo ? { custom_template_config_info: customTemplateConfigInfo } : {}),
                template_type: "barcode_printout_template",
                template_layout: current_template_layout_selected.value
            }
        } else {

            payload = {
                _id: config_check_info._id,
                barcode_display: config_check_info.barcode_display,
                profile_name: config_check_info.profile_name,
                weight_display: config_check_info.weight_display,
                price_display: config_check_info.price_display,
                qr_type_display: config_check_info.qr_type_display,
                qr_url_display: config_check_info.qr_url_display,
                qr_url_depend_location: config_check_info.qr_url_depend_location,
                text_message: config_check_info.text_message,
                text_font_size: templateConfigData.text_font_size,
                text_config: templateConfigData.text_config,
                image_config: templateConfigData.image_config,
                template3_field_positions: templateConfigData.template3_field_positions,
                with_code: config_check_info.with_code,
                normal_encode_pre_suf_fix: config_check_info.normal_encode_pre_suf_fix || { prefix: "", suffix: "" },
                profile_setup_info: templateConfigData,
                ...(customTemplateConfigInfo ? { custom_template_config_info: customTemplateConfigInfo } : {}),
                template_type: "barcode_printout_template",
                template_layout: current_template_layout_selected.value
            }
        }



        const updateData = await _Api(payload, 'api/v1/template-printout/update')
        if (updateData) {
            let GetloadingID = loading();

            Updateloading(t, GetloadingID, t("Successfully Update Printing Layout"));
            setUpdate(!update)
            const updatedProfileId = config_check_info._id || profileId;
            if (updatedProfileId) {
                window.location.href = `/app/admin/setup/barcode/${updatedProfileId}`;
            } else {
                window.location.reload(false);
            }
        } else {

        }
    }




    const setBarCodeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.barcode_display == "stock_id") {
            objSelect = {
                "label": "Stock ID",
                "value": "stock_id"
            }
        } else {
            objSelect = {
                "label": "SKU",
                "value": "sku"

            }
        }
        return objSelect;
    }

    const setQrTypeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.qr_type_display === "online") {
            objSelect = {
                "label": "Online",
                "value": "online"
            }
        } else if (checkConfigData.config_check_info.qr_type_display === "product_page") {
            objSelect = {
                "label": "Product Page",
                "value": "product_page"

            }
        } else {
            objSelect = {
                "label": "Offline",
                "value": "offline"

            }
        }
        return objSelect;
    }


    const setWeightTypeDisplaySelectLabel = (value) => {
        let objSelect = {};
        if (checkConfigData.config_check_info.qr_type_display == "gwt") {
            objSelect = {
                "label": "GWT",
                "value": "gwt"
            }
        } else {
            objSelect = {
                "label": "Nwt",
                "value": "nwt"

            }
        }
        return objSelect;
    }



    const setPriceDisplaySelectLabel = (value) => {
        const selected = checkConfigData.config_check_info.price_display;
        if (selected === "retail_price") {
            return { label: "Retail Price", value: "retail_price" };
        }
        if (selected === "with_currency") {
            return { label: "With Currency", value: "with_currency" };
        }
        if (selected === "with_code") {
            return { label: "Price Code", value: "with_code" };
        }
        if (selected === "with_custom_code") {
            return { label: "Custom Price Code", value: "with_custom_code" };
        }
        return null;
    }

    const selectedTemplateValue = getSelectedTemplateValue(checkConfigData.current_template_layout_selected);
    const showPriceAffix = checkConfigData.config_check_list.includes("price")
        && ["retail_price", "with_currency"].includes(checkConfigData.config_check_info.price_display);
    const selectedTemplateConfig = getTemplateConfigByValue(selectedTemplateValue);

    return (

        <React.Fragment>



            <h2>Create Label</h2>
            <div className="barcode_config_layout barcode_profile_builder_layout">
            <div className="barcode_config_panel">


                <div style={{ marginLeft: "15px", marginBottom: "20px", position: "relative" }} ref={profileNameRef}>
                    <Label className="profile_name_label" >
                        Label <span style={{ color: "red" }}>*</span>
                    </Label>

                    <input type="text" id="profile_name" placeholder="Fill your label name" value={checkConfigData.config_check_info.profile_name ? checkConfigData.config_check_info.profile_name : ""} onChange={(e) => {
                        changeInputWithFieldName(e, 'profile_name')
                    }} />

                </div>




                <Select
                    styles={{

                        control: (base, state) => ({
                            ...base,
                            '&:focus': { border: '1px solid red', boxShadow: '1px solid red', borderColor: 'red' }, // border style on hover
                            border: '1px solid lightgray', // default border color
                            boxShadow: 'none', // no box-shadow
                        }),
                    }}
                    className="short template_select"
                    options={checkConfigData.selected_options}
                    value={checkConfigData.current_template_layout_selected}
                    onChange={selectTemplatePrintout}
                    ref={templateSelectionRef}
                // defaultValue={checkConfigData.current_template_layout_selected?checkConfigData.current_template_layout_selected:{label: "please select template name", value: ""}}
                />
                <div className="check_uncheck_block">
                    <button className="check_select_button check_all_config"
                        onClick={() => {
                            setCheckConfigData((prev) => {
                                const templateConfig = getTemplateConfigByValue(selectedTemplateValue) || {};
                                return {
                                    ...prev,
                                    config_check_list: Object.keys(templateConfig),
                                };
                            })
                            setUpdate((value) => !value)
                        }}
                    >Select All</button>
                    <button className="check_select_button uncheck_all_config" onClick={() => {
                        setCheckConfigData((prev) => {
                            return { ...prev, config_check_list: [] };
                        })
                        setUpdate((value) => !value)
                    }} >Unselect All</button>
                    <button
                        className="check_select_button reset_default_config"
                        type="button"
                        onClick={resetToDefault}
                        disabled={!selectedTemplateValue}
                    >Reset Default</button>
                </div>
                {selectedTemplateConfig ?

                    <div className="config_block" id={selectedTemplateValue || "config"}>


                        {Object.keys(selectedTemplateConfig).map((v, k, a) => {
                            return (


                                <div className={`barcode-label-select ${v.search("price") == 0 && showPriceAffix ? "price_affix_grid" : ""}`} key={k}>


                                    {
                                        v == "s" ? <div></div> : ""
                                    }
                                    <div className="barcode_block">
                                        <input className='' type='checkbox' id={v} value={v} checked={checkConfigData.config_check_list.includes(v) ? true : false} onClick={checkConfig} />

                                        <label className='text-center bg-f2 ml-3' style={{ marginLeft: "5px" }} htmlFor={v} key={k} >{t(v).replace(/_/g, ' ')}</label>
                                    </div>


                                    {
                                        v.search("barcode") >= 0 && checkConfigData.config_check_list.includes("barcode") ?
                                            <div className="sku_stockid_block">

                                                <Select
                                                    required="required"
                                                    className="barcode_display barcode_selection sku_stockid_selection"
                                                    placeholder="Select data what you need to show in barcode  "
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "SKU",
                                                            "value": "sku"
                                                        },
                                                        {
                                                            "label": "Stock ID",
                                                            "value": "stock_id"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'barcode_display')
                                                    }}
                                                    defaultValue={setBarCodeDisplaySelectLabel(checkConfigData.config_check_info.barcode_display)}
                                                />





                                            </div>
                                            : ""
                                    }

                                    {v === "barcode" && checkConfigData.config_check_list.includes("barcode") ? (
                                        <>
                                            {renderTemplate3FieldPositionControls("sku", "SKU")}
                                            {renderTemplate3FieldPositionControls("stock_id", "Stock ID")}
                                        </>
                                    ) : null}

                                    {
                                        v.search("weight") == 0 && checkConfigData.config_check_list.includes("weight") ?
                                            <div className="weight_selection_block">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection weight_display"
                                                    placeholder={t('Select weight type what you need to show in barcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "GWT",
                                                            "value": "gwt"
                                                        },
                                                        {
                                                            "label": "NWT",
                                                            "value": "nwt"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'weight_display')
                                                    }}

                                                    defaultValue={setWeightTypeDisplaySelectLabel(checkConfigData.config_check_info.weight_display)}
                                                />
                                            </div>
                                            : ""}

                                    {v === "metal" && checkConfigData.config_check_list.includes("metal")
                                        ? renderTemplate3FieldPositionControls("metal", "Metal")
                                        : null}
                                    {v === "weight" && checkConfigData.config_check_list.includes("weight")
                                        ? renderTemplate3FieldPositionControls("weight", "Weight", true)
                                        : null}
                                    {v === "pcs" && checkConfigData.config_check_list.includes("pcs")
                                        ? renderTemplate3FieldPositionControls("pcs", "Pcs", true)
                                        : null}

                                    {
                                        v.search("text") == 0 && checkConfigData.config_check_list.includes("text") ?
                                            <div className="text_input_block">

                                                <input type="text" placeholder="Ex. Made From Thailand" className="barcode_custom_value_input" id="text_message" style={{}} onChange={(e) => {
                                                    changeInputWithFieldName(e, 'text_message')
                                                }} value={checkConfigData.config_check_info.text_message ? checkConfigData.config_check_info.text_message : ""}


                                                />
                                                <label className="barcode_text_font_size_label" htmlFor="text_font_size">Font size</label>
                                                <input
                                                    type="text"
                                                    inputMode="decimal"
                                                    id="text_font_size"
                                                    className="barcode_text_font_size_input"
                                                    min="1"
                                                    max="20"
                                                    step="0.5"
                                                    value={checkConfigData.config_check_info.text_font_size ?? DEFAULT_TEXT_FONT_SIZE}
                                                    onChange={(e) => changeNumericInputWithFieldName(e, 'text_font_size')}
                                                />
                                                {selectedTemplateValue === "template_3" ? (
                                                    <div className="barcode_template3_position_controls">
                                                        <div className="barcode_template3_position_block">
                                                            <label htmlFor="template3_text_x">X</label>
                                                            <input
                                                                id="template3_text_x"
                                                                type="text"
                                                                inputMode="decimal"
                                                                min="0"
                                                                max="70"
                                                                step="0.1"
                                                                value={checkConfigData.config_check_info?.text_config?.position?.x ?? TEMPLATE3_DEFAULT_TEXT_POSITION.x}
                                                                onChange={(event) => changeTextPosition(event, "x")}
                                                            />
                                                            <label htmlFor="template3_text_y">Y</label>
                                                            <input
                                                                id="template3_text_y"
                                                                type="text"
                                                                inputMode="decimal"
                                                                min="0"
                                                                max="30"
                                                                step="0.1"
                                                                value={checkConfigData.config_check_info?.text_config?.position?.y ?? TEMPLATE3_DEFAULT_TEXT_POSITION.y}
                                                                onChange={(event) => changeTextPosition(event, "y")}
                                                            />
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className={`barcode_template3_lock_button${checkConfigData.config_check_info?.text_config?.position_locked ? " is-locked" : ""}`}
                                                            title={checkConfigData.config_check_info?.text_config?.position_locked ? "Unlock text position" : "Lock text position"}
                                                            aria-label={checkConfigData.config_check_info?.text_config?.position_locked ? "Unlock text position" : "Lock text position"}
                                                            onClick={toggleTextPositionLock}
                                                        >
                                                            {checkConfigData.config_check_info?.text_config?.position_locked ? <FiLock aria-hidden="true" /> : <FiUnlock aria-hidden="true" />}
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>
                                            : ""
                                    }

                                    {
                                        v.search("image") == 0 && checkConfigData.config_check_list.includes("image") ?
                                            <div className="barcode_image_input_block">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="barcode_image_input"
                                                    onChange={changeImage}
                                                />
                                                <div className="barcode_image_settings_row">
                                                    {checkConfigData.config_check_info?.image_config?.data ? (
                                                        <img
                                                            className="barcode_image_config_preview"
                                                            src={checkConfigData.config_check_info.image_config.data}
                                                            alt="Grayscale label image"
                                                        />
                                                    ) : (
                                                        <span className="barcode_image_help">
                                                            Grayscale PNG, max 2 MB source
                                                        </span>
                                                    )}
                                                    {selectedTemplateValue === "template_3" ? (
                                                        <div className="barcode_image_scale_block">
                                                            <label htmlFor="template3_image_scale">Scale</label>
                                                            <input
                                                                id="template3_image_scale"
                                                                type="text"
                                                                inputMode="decimal"
                                                                min="0.1"
                                                                max="2"
                                                                step="0.1"
                                                                value={checkConfigData.config_check_info?.image_config?.scale ?? TEMPLATE3_DEFAULT_IMAGE_SCALE}
                                                                onChange={changeImageScale}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className="barcode_image_size_block">
                                                            <label htmlFor="barcode_image_width">W (mm)</label>
                                                            <input
                                                                id="barcode_image_width"
                                                                type="text"
                                                                inputMode="decimal"
                                                                min="1"
                                                                max="75"
                                                                step="0.1"
                                                                value={checkConfigData.config_check_info?.image_config?.size?.width ?? 8}
                                                                onChange={(event) => changeImageSize(event, "width")}
                                                            />
                                                            <label htmlFor="barcode_image_height">H (mm)</label>
                                                            <input
                                                                id="barcode_image_height"
                                                                type="text"
                                                                inputMode="decimal"
                                                                min="1"
                                                                max="14"
                                                                step="0.1"
                                                                value={checkConfigData.config_check_info?.image_config?.size?.height ?? 8}
                                                                onChange={(event) => changeImageSize(event, "height")}
                                                            />
                                                        </div>
                                                    )}
                                                    {selectedTemplateValue === "template_3" ? (
                                                        <div className="barcode_template3_position_controls">
                                                            <div className="barcode_template3_position_block">
                                                                <label htmlFor="template3_image_x">X</label>
                                                                <input
                                                                    id="template3_image_x"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    min="0"
                                                                    max="70"
                                                                    step="0.1"
                                                                    value={getTemplate3ImagePositionValue(checkConfigData.config_check_info?.image_config, "x")}
                                                                    onChange={(event) => changeImagePosition(event, "x")}
                                                                />
                                                                <label htmlFor="template3_image_y">Y</label>
                                                                <input
                                                                    id="template3_image_y"
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    min="0"
                                                                    max="30"
                                                                    step="0.1"
                                                                    value={getTemplate3ImagePositionValue(checkConfigData.config_check_info?.image_config, "y")}
                                                                    onChange={(event) => changeImagePosition(event, "y")}
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className={`barcode_template3_lock_button${checkConfigData.config_check_info?.image_config?.position_locked ? " is-locked" : ""}`}
                                                                title={checkConfigData.config_check_info?.image_config?.position_locked ? "Unlock image position" : "Lock image position"}
                                                                aria-label={checkConfigData.config_check_info?.image_config?.position_locked ? "Unlock image position" : "Lock image position"}
                                                                onClick={toggleImagePositionLock}
                                                            >
                                                                {checkConfigData.config_check_info?.image_config?.position_locked ? <FiLock aria-hidden="true" /> : <FiUnlock aria-hidden="true" />}
                                                            </button>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            : ""
                                    }

                                    {
                                        v.search("price") == 0 && checkConfigData.config_check_list.includes("price") ?
                                            <div className="text_seletion_block price_selection_with_affix">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection weight_selection"
                                                    placeholder={t('Select price data to show in barcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "Retail Price",
                                                            "value": "retail_price"
                                                        },

                                                        {
                                                            "label": "With Currency",
                                                            "value": "with_currency"
                                                        },
                                                        {
                                                            "label": "Price Code",
                                                            "value": "with_code"
                                                        },
                                                        {
                                                            "label": "Custom Price Code",
                                                            "value": "with_custom_code"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'price_display')
                                                    }}
                                                    value={setPriceDisplaySelectLabel(checkConfigData.config_check_info.price_display)}
                                                />

                                            </div>
                                            : ""
                                    }
                                    {v === "price" && checkConfigData.config_check_list.includes("price")
                                        ? renderTemplate3FieldPositionControls("price", "Price")
                                        : null}
                                    {
                                        v.search("price") == 0 && showPriceAffix ? (
                                            <>
                                                {/* Grid row 1, beside the Price checkbox label */}
                                                <div className="price_affix_labels">
                                                    <label className="price_affix_label" htmlFor="price_affix_prefix">{t("Prefix")}</label>
                                                    <label className="price_affix_label" htmlFor="price_affix_suffix">{t("Suffix")}</label>
                                                </div>
                                                {/* Grid row 2, beside the price select */}
                                                <div className="price_affix_inputs">
                                                        <input
                                                            id="price_affix_prefix"
                                                            type="text"
                                                            className="barcode_custom_value_input"
                                                            autoComplete="off"
                                                            value={checkConfigData.config_check_info.normal_encode_pre_suf_fix?.prefix || ""}
                                                            ref={priceAffixPrefixRef}
                                                            onKeyDown={(e) => handlePriceAffixKeyDown(e, "prefix")}
                                                            onChange={(e) => changeNormalPriceAffix("prefix", e.target.value)}
                                                        />
                                                        <input
                                                            id="price_affix_suffix"
                                                            type="text"
                                                            className="barcode_custom_value_input"
                                                            autoComplete="off"
                                                            value={checkConfigData.config_check_info.normal_encode_pre_suf_fix?.suffix || ""}
                                                            ref={priceAffixSuffixRef}
                                                            onKeyDown={(e) => handlePriceAffixKeyDown(e, "suffix")}
                                                            onChange={(e) => changeNormalPriceAffix("suffix", e.target.value)}
                                                        />
                                                </div>
                                            </>
                                        ) : null
                                    }
                                    {
                                        v.search("qr") == 0 && checkConfigData.config_check_list.includes("qr") ?
                                            <div className="text_seletion_block">
                                                <Select
                                                    required="required"
                                                    className="barcode_selection qr_type_selection"
                                                    placeholder={t('Select type of qrcode')}
                                                    inputMode="none"
                                                    options={[

                                                        {
                                                            "label": "Offline",
                                                            "value": "offline"
                                                        },
                                                        {
                                                            "label": "Online",
                                                            "value": "online"
                                                        },
                                                        {
                                                            "label": "Product Page",
                                                            "value": "product_page"
                                                        }
                                                    ]}
                                                    onChange={(e) => {
                                                        changeSelectWithFieldName(e, 'qr_type_display')
                                                    }}
                                                    value={setQrTypeDisplaySelectLabel(checkConfigData.config_check_info.barcode_display)}
                                                />

                                                {checkConfigData.config_check_info.qr_type_display == "online" ?
                                                    <div className="qr_url_display">
                                                        <input type="text" onChange={(e) => {
                                                            changeInputWithFieldName(e, 'qr_url_display')
                                                        }} value={checkConfigData.config_check_info.qr_url_display ? checkConfigData.config_check_info.qr_url_display : ""} />

                                                    </div>
                                                    : ""}

                                                {/* {checkConfigData.config_check_info.qr_type_display=="online"? 
                        <div className="qr_url_display">
                     <label className='text-center bg-f2 ml-3' style={{marginRight:"5px"}} htmlFor="depend_on_location" >Depend on location store</label>
        
                            <input type="checkbox" id="depend_on_location"  onChange={checkDependStoreLocation}/>
        
                        </div>
                        :""} */}


                                            </div>


                                            : ""
                                    }


                                </div>
                            )

                        }




                        )}

                    </div>

                    : ""}

                <div className="action_profile_block">
                    <div className="add_profile">


                        <button
                            className="cancel_profile_data"
                            type="button"
                            onClick={() => {
                                // config_check_list:[],config_check_info:{},current_template_layout_selected:"",selected_options:selectOptions
                                setPageStatus("list_profile_page")
                                setCheckConfigData((prev) => {
                                    let obj = prev
                                    obj.config_check_list = []
                                    obj.config_check_info = {}
                                    obj.current_template_layout_selected = ""
                                    return obj
                                }



                                )


                            }}
                        >

                            {t('Cancel')}
                        </button>

                        {checkConfigData.config_check_info._id ?
                            <button
                                className="save_barcode_printout"
                                type="button"
                                onClick={() => {

                                    updateProfile({ template: currentSelectTemplate.value, profile_config: checkConfigData, t: t })

                                }}
                            >

                                {t('Update')}
                            </button>


                            :
                            <>

                                <button
                                    className="save_barcode_printout"
                                    type="button"
                                    onClick={() => {
                                        if (!checkConfigData.config_check_info.profile_name) {
                                            var wrapper = document.createElement('div');
                                            profileNameRef.current.children[0].focus()
                                            profileNameRef.current.children[1].focus()
                                            // profileNameRef.current.getElementById("profile_name");
                                        }
                                        if (!checkConfigData.current_template_layout_selected.value) {
                                            templateSelectionRef.current.focus()
                                        }
                                        saveProfile({ template: currentSelectTemplate.value, profile_config: checkConfigData, t: t })

                                    }}
                                >

                                    {t('Save')}
                                </button>

                            </>


                        }


                    </div>
                </div>
            </div>
            <BarcodeConfigPreview
                key={profileId || "new-profile"}
                checkConfigData={checkConfigData}
                resetKey={previewResetKey}
            />
            {checkConfigData.config_check_list.includes("price") &&
            checkConfigData.config_check_info.price_display === "with_code" ? (
                <div className="price_code_panel">
                    <div className="price_code_panel-head">
                        <h3 className="price_code_panel-title">{t("Price Code")}</h3>
                        <p className="price_code_panel-hint">{t("One character per key. The price prints as this code instead of digits.")}</p>
                    </div>

                    <div className="price_code_group">
                        <span className="price_code_group-label">{t("Digits")}</span>
                        <div className="price_code_panel-grid">
                            {PRICE_CODE_DIGIT_FIELDS.map((field) => (
                                <div className="price_code_field" key={field.key}>
                                    <label className="price_code_field-label" htmlFor={`price_code_${field.key}`}>
                                        {field.label}
                                    </label>
                                    {renderPriceCodeInput(field)}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="price_code_group">
                        <span className="price_code_group-label">{t("Special")}</span>
                        <div className="price_code_specials">
                            {PRICE_CODE_SPECIAL_FIELDS.map((field) => (
                                <div className="price_code_special" key={field.key}>
                                    {renderPriceCodeInput(field)}
                                    <div className="price_code_special-text">
                                        <label className="price_code_special-label" htmlFor={`price_code_${field.key}`}>
                                            {t(field.label)}
                                        </label>
                                        <span className="price_code_special-hint">{t(field.hint)}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="price_code_preview">
                        <span className="price_code_preview-label">{t("Preview")}</span>
                        <input
                            type="text"
                            className="price_code_preview-input"
                            value={priceCodePreviewValue}
                            placeholder="1,250.00"
                            inputMode="decimal"
                            autoComplete="off"
                            onChange={(e) => handlePriceCodePreviewChange(e.target.value)}
                            onKeyDown={handlePriceCodePreviewKeyDown}
                            onPaste={(e) => {
                                e.preventDefault();
                                handlePriceCodePreviewChange(e.clipboardData.getData("text"));
                            }}
                        />
                        <span className="price_code_preview-arrow">→</span>
                        <span className="price_code_preview-code">
                            {priceCodePreviewValue
                                ? encodePricePreview(priceCodePreviewValue, checkConfigData.config_check_info.with_code)
                                : ""}
                        </span>
                    </div>
                </div>
            ) : null}
            </div>

        </React.Fragment>
    )


}


const BarcodePrintOut = () => {
    return (
        <RecoilRoot>
            <BarcodePrintOutPage />

        </RecoilRoot>

    )

}
export default BarcodePrintOut;
